module.exports = __webpack_public_path__ + "img/1.794b8232.png";